import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Radar, TrendingUp } from "lucide-react";

export const TrendingWantsCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/match/open-demands?limit=8").then(({ data }) => setData(data)).catch(() => setData({ demands: [] }));
  }, []);

  if (!data || data.demands.length === 0) return null;

  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="trending-wants-card">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <TrendingUp className="h-4 w-4 text-[#FF9F0A]" />
          <h3 className="font-black text-xl tracking-tight">What buyers want right now</h3>
        </div>
        <Link to="/open-demands" data-testid="trending-wants-all" className="text-xs text-[#007AFF] hover:underline">
          See all →
        </Link>
      </div>
      <p className="mt-1 text-sm text-neutral-400">
        Live buyer demands — list a matching product and the buyer is alerted instantly.
        {data.unfilled_count > 0 && (
          <span className="text-[#FF9F0A] font-semibold"> {data.unfilled_count} still unfilled.</span>
        )}
      </p>
      <div className="mt-4 grid sm:grid-cols-2 gap-2">
        {data.demands.slice(0, 8).map((d, i) => (
          <div key={i} className="flex items-start gap-2 rounded-lg border border-[#27272A] bg-[#0A0A0A] px-3 py-2.5">
            <Radar className={`h-3.5 w-3.5 mt-0.5 shrink-0 ${d.unfilled ? "text-[#FF9F0A]" : "text-[#34C759]"}`} />
            <div className="min-w-0">
              <div className="text-sm text-white truncate">“{d.text}”</div>
              <div className="text-[11px] text-neutral-500">
                {d.max_price ? `budget $${d.max_price}` : "any price"} ·{" "}
                {d.unfilled ? "unfilled — be first" : `${d.matches_total} match${d.matches_total > 1 ? "es" : ""}`}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
